import { render, staticRenderFns } from "./UserFaq.vue?vue&type=template&id=0d3cef6e&scoped=true&"
import script from "./UserFaq.vue?vue&type=script&lang=js&"
export * from "./UserFaq.vue?vue&type=script&lang=js&"
import style0 from "./UserFaq.vue?vue&type=style&index=0&id=0d3cef6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3cef6e",
  null
  
)

export default component.exports